import { IShippingRequestPayload, IShipping } from '@/models'
import { api } from '@/api/api'

export async function createShipping(
    orderCode: string,
    payload: IShippingRequestPayload
): Promise<IShipping> {
    const { data: shipping } = await api.post(`shipping/start/${orderCode}`, payload)

    return { ...shipping, shippingMethodID: payload.methodID }
}
